import React from 'react';

interface Step2B_CompanyTypeProps {
  selectedType: 'premium' | 'solid' | 'any' | null;
  onSelect: (type: 'premium' | 'solid' | 'any') => void;
}

const Step2B_CompanyType: React.FC<Step2B_CompanyTypeProps> = ({ selectedType, onSelect }) => {
  return (
    <div className="wizard-step">
      <div className="wizard-step-content">
        <h2 className="wizard-question">
          What type of companies do you prefer for this strategy?
        </h2>

        <div className="wizard-options-container">
          <button
            className={`wizard-pill-button ${selectedType === 'premium' ? 'selected' : ''}`}
            onClick={() => onSelect('premium')}
            aria-pressed={selectedType === 'premium'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Premium & stable</div>
              <div className="pill-button-subtitle">
                Strong brands, steadier returns, lower income
              </div>
              <div className="pill-button-details">
                Net Margin ≥15% • Debt/Equity ≤0.5 • High quality
              </div>
            </div>
          </button>

          <button
            className={`wizard-pill-button ${selectedType === 'solid' ? 'selected' : ''}`}
            onClick={() => onSelect('solid')}
            aria-pressed={selectedType === 'solid'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Solid & balanced</div>
              <div className="pill-button-subtitle">
                Reliable, good income potential
              </div>
              <div className="pill-button-details">
                Net Margin ≥5% • Debt/Equity ≤1.0 • Balanced approach
              </div>
            </div>
          </button>

          <button
            className={`wizard-pill-button ${selectedType === 'any' ? 'selected' : ''}`}
            onClick={() => onSelect('any')}
            aria-pressed={selectedType === 'any'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Any opportunity</div>
              <div className="pill-button-subtitle">
                Broader selection, higher income, more risk
              </div>
              <div className="pill-button-details">
                Net Margin ≥0% • Debt/Equity ≤1.5 • More opportunities
              </div>
            </div>
          </button>
        </div>

        <p className="wizard-helper-text">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{display: 'inline', marginRight: '6px', verticalAlign: 'text-bottom'}}>
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          This filters stocks by their financial health and stability.
        </p>
      </div>
    </div>
  );
};

export default Step2B_CompanyType;
